// src/Webmdnbeta.js

import React from 'react';
import useSpeechRecognition from '../hooks/speech-recognition';
import Parea from './realtime/nParea';
const Webmdnbeta = () => {
  const { text, isListening, startListening, stopListening } = useSpeechRecognition();

  return (
    <div className="content-section">
      <h2>Quick Notes:</h2>
      <button className='content-button status-button open' onClick={startListening} disabled={isListening}>Start</button>
      <button className='content-button status-button open' onClick={stopListening} disabled={!isListening}>Stop</button>
      {isListening && <p className="listening-indicator">🎙️ Listening...</p>}
      <p className="app-card2__subtext">{text}</p>
      <Parea logs={text} />
      <div className="disclaimer">
        <p><strong>Disclaimer:</strong> This speech recognition feature may not work on all browsers and is intended for quick notes only. It's not as accurate as real-time transcription services and may not be suitable for complex tasks.</p>
      </div>
    </div>
  );
};

export default Webmdnbeta;
